module.exports = __webpack_public_path__ + "dist/media/ec_comp_breadcrumb.4ae8ff37.svg";